import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "authentication-wrapper authentication-2 px-4" }
const _hoisted_2 = { class: "authentication-inner py-5" }
const _hoisted_3 = { class: "d-flex justify-content-center align-items-center mb-5" }
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "p-4 p-sm-5" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-danger"
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-danger"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "mt-2 text-sm text-danger"
}
const _hoisted_15 = {
  key: 0,
  class: "text-center"
}
const _hoisted_16 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _ctx.imageURL,
            alt: _ctx.partner +' Logo',
            title: _ctx.partner +' Logo',
            height: "75"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _withDirectives(_createElementVNode("form", {
        class: "card",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-center text-muted mb-4" }, "Change Password", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "email",
              class: "form-label"
            }, " Email address ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "email",
              name: "email",
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email.value) = $event)),
              autocomplete: "email",
              disabled: _ctx.loading,
              required: "",
              class: _normalizeClass([_ctx.form.email.valid ? '' : 'border-danger', "form-control"]),
              placeholder: "Enter your email address"
            }, null, 10, _hoisted_7), [
              [_vModelText, _ctx.form.email.value]
            ]),
            (!_ctx.form.email.valid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.form.email.validationMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "password",
              class: "form-label"
            }, " New Password ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              name: "new_password",
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password.value) = $event)),
              disabled: _ctx.loading,
              required: "",
              class: _normalizeClass([_ctx.form.email.valid ? '' : 'border-danger', "form-control"])
            }, null, 10, _hoisted_10), [
              [_vModelText, _ctx.form.password.value]
            ]),
            (!_ctx.form.password.valid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.form.password.validationMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "password_confirmation",
              class: "form-label"
            }, " Confirm New Password ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password_confirmation",
              name: "re_password",
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password_confrimation.value) = $event)),
              disabled: _ctx.loading,
              required: "",
              class: _normalizeClass([_ctx.form.password_confrimation.valid ? '' : 'border-danger', "form-control"])
            }, null, 10, _hoisted_13), [
              [_vModelText, _ctx.form.password_confrimation.value]
            ]),
            (!_ctx.form.password_confrimation.valid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.form.password_confirmation.validationMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary btn-block"
          }, "Change Password", -1))
        ])
      ], 544), [
        [_vShow, _ctx.showForm]
      ]),
      _createElementVNode("div", null, [
        (!_ctx.showForm)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_15, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.showForm)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "mt-2 font-medium text-primary",
                to: "/login"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Back to Login")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.showForm)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "mt-2 font-medium text-primary",
                to: "/dashboard"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("Continue to dashboard >>")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ]))
}